import { Request } from '@jfs/network'
import { getAPIURL, getPaymentHeader } from '../config'
import { executeRequest } from './../../../../../libs/network/src/network'
const responseParser = (response: any) => {
  const { data } = response?.data
  return data
}

/**
 * New PG
 * To cancel the payment intent
 * @param intentId
 */
const cancelIntent = (intentId: string) => {
  const request: Request<{}> = {
    apiPath: `${getAPIURL('cancelIntent')}${intentId}/cancel`,
    method: 'POST',
    headers: getPaymentHeader(),
  }

  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .catch((err) => {
      const {
        data: { error },
      } = err
      throw error
    })
}

export { cancelIntent }
